import React, { useState, useEffect } from 'react'
import SearchIco from '../../../static/icons/ico_search.svg'
import useI18n from 'src/hooks/useI18n'

const InputSearch = () => {
  const [searchString, setSearchString] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const searchParam = params.get('q')
    if (searchParam) setSearchString(searchParam)
  }, [])

  const searchHandler = () => {
    window.location.href = `/busca?q=${searchString}`
  }

  const keyboardHandler = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      searchHandler()
    }
  }

  const translation = useI18n()

  return (
    <div className="vnda-search-input-container">
      <div className="input-wrapper">
        <button onClick={searchHandler}>
          <img src={SearchIco} />
        </button>
        <input
          className="vnda-search-input-field"
          placeholder={translation.filter.search.placeholder}
          value={searchString}
          onChange={(event) => setSearchString(event.target.value)}
          onKeyDown={keyboardHandler}
        />
      </div>
      <div className="text-wrapper">
        <span>{translation.filter.search.cta}</span>
      </div>
    </div>
  )
}

export default InputSearch
